export default __webpack_public_path__ + "media/images/upgrade-banner-background-df142c14.png";